import { useEffect, useState } from "react";

import PageHeader from "../../components/PageHeader/index";

import { motion } from "framer-motion";
import homeImageBackground from "../../assets/images/homeBackground.png";
import RecipesList from "../../components/BlogList/index";
import Header from "../../components/Header";
import Loader from "../../components/Loader";
import { SearchInput } from "./styles";
import Layout from "../../components/Layout";
import {
  ContainerHeading,
  CookEInput,
} from "../../components/CommonComponents";
import { getArticles } from "../../utils/apiServices/blogServices";

function Blogs() {
  const [articles, setArticles] = useState([]);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        setLoading(true);
        const data = await getArticles();
        setArticles(data.items);
        setFilteredArticles(data.items);
        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    };

    fetchArticles();
  }, []);

  const onChangeSearch = (event) => {
    setSearch(event.target.value);

    if (event.target.value.trim() === "") {
      setFilteredArticles(articles);
      return;
    }

    const filtered = articles.filter((recipe) =>
      recipe.title.toLowerCase().includes(event.target.value.toLowerCase())
    );

    setFilteredArticles(filtered);
  };

  return (
    <Layout>
      <ContainerHeading
        text={"Blogs"}
        description={"Check out our latest blogs"}
      />
      <CookEInput
        onChange={onChangeSearch}
        value={search}
        placeholder="Enter your keywords"
        type="search"
      />

      {loading ? <Loader /> : <RecipesList recipes={filteredArticles} />}
    </Layout>
  );
}

export default Blogs;
